<template>
    <modal name="modal-request-custom-design" :pivotY="0.2" :width="1200" height="auto" >
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="hideModal('modal-request-custom-design')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="modal-title-big">
            Применить выбранный дизайн на свой дом
        </div>
        <div class="modal-text">
            Отправьте фотографии Вашего проекта и оставьте свои контактные данные. Наши менеджеры вскоре свяжутся с Вами!
        </div>
        <div class="cd-modal-outer-grid">
            <div>
                <div>
                    <div class="cd-modal-grid-element">
                        <div class="dnd-container" @drop.prevent="receiveFiles" @dragover.prevent="dragover=true" @dragleave.prevent="dragover=false" @click="$refs.file.click()">
                            <SVGPhotoDnDLoad :dragover="dragover" class="cd-dnd-svg"/>
                        </div>
                        <input type="file" id="fileInputModal" ref="file" v-on:change="handleFileUpload( $event)" accept=".jpg,.png" multiple hidden>
                    </div>
                </div>
                <div>
                    <div v-if="Object.keys(uploadedPhotos).length === 0" class="cd-modal-grid-element cd-photo-tips">
                        <ul>
                            <li class="cd-modal-list">
                                Размер файла не более 15 МБ
                            </li>
                            <li class="cd-modal-list">
                                Форматы: JPG, JPEG, PNG
                            </li>
                            <li class="cd-modal-list">
                                Изображение объекта в фокусе
                            </li>
                            <li class="cd-modal-list">
                                Ракурс без заваленных вертикальных линий
                            </li>
                            <li class="cd-modal-list">
                                Здание полностью помещается в кадр
                            </li>
                            <li class="cd-modal-list">
                                Фото сделано при достаточном освещении
                            </li>
                            <li class="cd-modal-list">
                                На фото отсутствуют посторонние объекты, мешающие обзору
                            </li>
                        </ul>
                    </div>
                    <vue-custom-scrollbar v-else class="margin-10-20 cd-modal-img-blocks">
                        <div v-for="img in uploadedPhotos" class="modal-img-block">
                            <img class="modal-img-block-image" :src="urlForPhoto(img.src)"/>
                        </div>
                    </vue-custom-scrollbar>
                </div>
            </div>
            <div>
                <div class="cd-modal-grid no-mt">
                    <div>
                        <div class="cd-modal-grid-element margin-10-20">
                            ФИО (Полностью) <span class="red-text">*</span>
                        </div>
                        <div class="cd-modal-grid-element">
                            <input type="text" class="cd-modal-text-input" v-model="name" placeholder="Ваше полное имя *">
                            <div class="form-alert-danger" v-show="showAlert === 'name'">
                                Обязательное поле!
                            </div>
                        </div>
                        <div class="cd-modal-grid-element margin-10-20">
                            Адрес электронной почты <span class="red-text">*</span>
                        </div>
                        <div class="cd-modal-grid-element">
                            <input type="text" class="cd-modal-text-input" v-model="email" placeholder="Ваша электронная почта *">
                            <div class="form-alert-danger" v-show="showAlert === 'email'">
                                Обязательное поле!
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="cd-modal-grid-element margin-10-20">
                            Город <span class="red-text">*</span>
                        </div>
                        <div class="cd-modal-grid-element">
                            <SelectRegionCity :hideRegions="true" :hideFieldLabels="true" @citySelectedName="citySelectedName" style="height: 38px"/>
                            <div class="form-alert-danger" v-show="showAlert === 'city'">
                                Обязательное поле!
                            </div>
<!--                            <input type="text" class="cd-modal-text-input" v-model="city" placeholder="Ваш город *">-->
                        </div>
                        <div class="cd-modal-grid-element margin-10-20">
                            Контактный телефон <span class="red-text">*</span>
                        </div>
                        <div class="cd-modal-grid-element">
                            <input type="text" class="cd-modal-text-input" v-model="phone" v-mask="'+# (###) ### ## ##'" v-on:focus="addCountryCode" placeholder="Ваш контактный телефон *">
                            <div class="form-alert-danger" v-show="showAlert === 'phone'">
                                Обязательное поле!
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cd-modal-grid-element margin-10-30">
                    <div class="margin-10-0">
                        Ваши комментарии:
                    </div>
                    <div>
                        <textarea class="cd-modal-text-input modal-textarea" v-model="comment" placeholder="Дополнительная информация к заявке *"></textarea>
                    </div>
                </div>

            </div>
        </div>
        <div class="button-alert-grid margin-30">
            <div class="gl-square-btn btn-grey" v-on:click="submitSendRequest">
                Отправить заявку
            </div>
            <div></div>
        </div>
    </modal>
</template>

<script>
import {modalMethods, urlForFileStorage} from "../common";
    import SVGModalClose from "../SVG/SVGModalClose.vue";
    import SVGPhotoDnDLoad from "../SVG/SVGPhotoDnDLoad.vue";
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import SelectRegionCity from "./AdminPage/SelectRegionCity";
    import {bus} from "../../vue_bus";
import store from "../../store";

    export default {
        name: "ModalRequestCustomDesign",
        components: {
            SelectRegionCity,
            SVGPhotoDnDLoad,
            SVGModalClose,
            vueCustomScrollbar
        },
        mixins: [modalMethods, urlForFileStorage],
        data () {
            return {
                dragover: false,
                name: '',
                email: '',
                phone: '',
                city: '',
                comment: '',
                fileTooLarge: false,
                necessaryFields: [
                    'name',
                    'email',
                    'phone',
                    'city'
                ],
                showAlert: ''
            }
        },
        computed:{
            uploadedPhotos(){
                return this.$store.getters['UI/requestCustomDesign/UPLOADED_PHOTOS'];
            },
            projectUUID() {
                return this.$route.params.projectUUID
            },
            designID() {
                return this.$route.params.designID
            },
            photoID() {
                return this.$route.params.photoID
            },
        },
        methods: {
            citySelectedName(name){
                this.city = name;
            },
            checkNecessary(data) {
                for (let field in this.necessaryFields) {
                    if (!data[this.necessaryFields[field]]) {
                        this.showAlert = this.necessaryFields[field]
                        console.log(this.showAlert)
                        return false
                    }
                }
                this.showAlert = ''
                console.log(this.showAlert)
                return true
            },
            addCountryCode() {
                if (this.phone === '') {
                    this.phone = 7
                }
            },
            receiveFiles(event) {
                for (let file in event.dataTransfer.files) {
                    if (event.dataTransfer.files[file].size/1048576 > 15) {
                        this.fileTooLarge = true
                        alert('Превышен максимальный допустимый размер одного из загружаемых файлов!');
                        return
                    }
                }
                this.fileTooLarge = false
                this.$store.dispatch('UI/requestCustomDesign/SAVE_PHOTOS', event.dataTransfer.files);
            },
            handleFileUpload(fileInput) {
                for (let file in fileInput.target.files) {
                    if (fileInput.target.files[file].size/1048576 > 15) {
                        this.fileTooLarge = true
                        alert('Превышен максимальный допустимый размер одного из загружаемых файлов!');
                        return
                    }
                }
                this.fileTooLarge = false
                this.$store.dispatch('UI/requestCustomDesign/SAVE_PHOTOS', fileInput.target.files);
            },
            async submitSendRequest() {
                let render_img = this.urlForFileStorage(this.$store.getters[`projectList/${this.projectUUID}/designList/${this.designID}/RENDERED_PHOTO_BY_ID`](this.photoID))
                let data = {
                    name: this.name,
                    phone: this.phone,
                    email: this.email,
                    city: this.city,
                    comment: this.comment,
                    design: render_img
                }
                console.log('data', data)
                const checkResult = this.checkNecessary(data);
                if (checkResult) {
                    if (this.$store.getters['UI/requestCustomDesign/THERE_IS_PHOTO']) {
                        await this.$store.dispatch('UI/requestCustomDesign/SEND_ORDER_TO_MANAGER', data);
                        this.hideModal("modal-request-custom-design");
                        bus.$emit('showModalSuccess', 'Ваша заявка успешно отправлена. Наш менеджер вскоре свяжется с вами!')
                    } else {
                        bus.$emit('showModalAlert', 'Необходимо загрузить хотя бы одну фотографию дома!')
                    }
                }
            },
            urlForPhoto(url) {
                return this.$store.getters[`projectConfiguration/GENERATE_URL`](url);
            },
        },
        mounted() {
            this.$store.dispatch('UI/requestCustomDesign/CREATE_NEW_PROJECT');
        }
    }
</script>

<style scoped>
    .cd-modal-img-blocks {
        overflow: auto;
        max-height: 180px;
        max-width: 455px;
    }

    .cd-modal-outer-grid {
        display: grid;
        grid-template-columns: max-content auto;
    }
    .cd-modal-grid-fix-size {
        grid-template-columns: 485px 485px;
    }

    .no-mt {
        margin-top: 0;
    }

    .cd-dnd-svg {
        width: 300px;
        height: auto;
    }

    .cd-photo-tips {
        font-size: 14px;
    }

    .margin-10-20 {
        margin: 10px 20px;
    }

    .margin-10-30 {
        margin: 10px 30px;
    }

    .margin-10-0 {
        margin: 10px 0;
    }

    .modal-textarea {
        resize: none;
        /*width: 910px;*/
        font-family: "Open Sans", sans-serif;
        font-size: 12px;
    }
</style>

